<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper nopadding-mobile">

  <h2 class="page-title">Issue Credit</h2>

  <!-- Issue Credit -->
  <div class="col-lg-8 col-md-8 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-1 nopadding-mobile">
    <div class="panel">

      <div class="col-sm-12">
        <div class="profile-sec-wrap panel-title">
        <p>Issuing Credit to:</p>

        <div class="push-up-10 push-down-10">K.raheloo@mind-berry.com</div></div>
      </div>

      <div class="col-sm-12">

        <p class="push-down-20">
          Please select the amount of credit you <br />wish to issue to the selected user
        </p>

        <div class="form-elem-inner">
          <div class="form-elem-name">Amount of credit to issue</div>
          <div class="form-elem-field">
            <select [formControl]="myForm.controls['credit']">
              <option></option>
              <option [ngValue]="0">1</option>
              <option [ngValue]="1">2</option>
              <option [ngValue]="2">3</option>
            </select>
            <div class="clear"></div>
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['credit'].valid && myForm.controls['credit'].touched">
              <div class="mb-error-fail">Please select amount of credit to issue</div>
            </div>
          </div>
        </div>

        <div class="class"></div>

        <div class="push-down-10"><button type="button" class="btn-main btn-full">Issue Credit</button></div>

        <div class="class"></div>
      </div>
      <div class="clear"></div>
    </div>
  </div>

  <div class="col-sm-12 nopadding-mobile">

    <!--Members-->
    <div class="panel">
      <div class="panel-title">Members</div>

      <div class="col-sm-12">
        <div class="profile-sec-wrap">
          <div class="">
            <div class="col-md-5 col-sm-5 col-xs-5 mb-table-title">Username</div>

            <div class="col-md-3 col-sm-3 col-xs-3 nopadding-mobile mb-table-title">Registered?</div>

            <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile mb-table-title">Issued Credits</div>

            <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile mb-table-title">Add Credit</div>

            <div class="clear"></div>

            <!-- Repeat per USER -->
            <div class="col-sm-12 nopadding">
              <div class="profile-content-alt">
                <div class="col-md-5 col-sm-5 col-xs-5">
                  <div class="mb-table-lg">k.raheloo@gmail.com</div>
                </div>

                <div class="col-md-3 col-sm-3 col-xs-3 nopadding-mobile">
                  <div class="mb-table-lg">Yes</div>
                </div>

                <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile">
                  <div class="mb-table-lg">999</div>
                </div>

                <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile">
                  <div class="mb-table-lg"><button type="button" class="btn-table-icon-simple-grey"><i class="fas fa-ticket-alt"></i></button></div>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <div class="clear"></div>
          </div>

          <div class="clear"></div>
        </div>

        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>
  </div>
</div>
